/**
 * The shape the JSON tab expects.
 *
 * The dialog itself is shared with the opt-in texts editor; what is announcement-specific is the
 * document below and the note about what the JSON leaves out.
 *
 * @module Pages/BUs/WhatsNew
 */

import type { JSX } from 'react';
import { SchemaDialog } from '@/Shared/components/SchemaDialog/SchemaDialog';

const SCHEMA = `{
  "welcomeMessage": { "pt": "", "en": "", "es": "" },
  "subtitle":       { "pt": "", "en": "", "es": "" },
  "footer":         { "pt": "", "en": "", "es": "" },
  "confirmButtonText": { "pt": "", "en": "", "es": "" },
  "actionParams": {
    "redirect_to": "device-list",
    "show_tour": true,
    "open_filter": false
  },
  "items": [
    {
      "icon": "Communication.Megaphone",
      "color": "#0033FF",
      "title": "",
      "body": "",
      "order": 0,
      "translations": {
        "pt": { "title": "", "body": "" },
        "en": { "title": "", "body": "" },
        "es": { "title": "", "body": "" }
      },
      "privileges": ["whats_new_page"]
    }
  ]
}`;

export interface SchemaModalProps {
  onClose: () => void;
}

export const SchemaModal = ({ onClose }: SchemaModalProps): JSX.Element => (
  <SchemaDialog
    title='Schema do conteúdo'
    description='O JSON cobre só o conteúdo — tenant, versão, página e use case vêm do passo 1.'
    schema={SCHEMA}
    onClose={onClose}
  >
    Campos ausentes viram vazios; <code>actionParams</code> e <code>privileges</code> são opcionais
    e somem do documento quando não usados.
  </SchemaDialog>
);
